import React, { Component } from "react";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import settings from "../../settings";

import Auth from "../../models/Auth";
import FetchResponses from "../../models/FetchResponses";
// redux
import { connect } from 'react-redux';
import { SetMenuManager } from '../Actions/Menu_Actions';
import { setModulos } from "../Actions/Modules_Actions";
import { withRouter } from 'react-router-dom'; 

class MenuList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      views: [], // Initial state
      modules: []
    };
  }

  componentDidMount() {
    // Simulate fetching the views from an external function
    if(this.props.modules){
      this.setState({modules:  this.props.modules})
    } else {
      this.getModules()
    }
  }

  getModules() {
    fetch(settings.backend.modules, {
      method: "GET",
      headers: settings.headers_auth(Auth.getSessionToken()),
    })
      .then(FetchResponses.processResponse)
      .then(this.successDataResponse)
      .catch(this.failureDataResponse);
  }

  successDataResponse = (response) => {    
    if(response.modules) {
      this.setState({modules: response.modules})
      this.props.setModulos(response.modules)
    }
  };

  failureDataResponse = () => {
    console.log('ERROR')
  };

  // Genérica para cambiar el estado del menú
  changeMenuState = (index) => {
    const menuArray = Array(8).fill("");  // Crea un arreglo con 8 elementos vacíos
    menuArray[index] = "submit";  // Establece "submit" en el índice especificado

    // Actualiza el estado global y el localStorage
    this.props.SetMenuManager(menuArray);
    localStorage.setItem("menu", JSON.stringify(menuArray));
  };


  render() {
    const { location } = this.props;
    
    return (
      <ul className="submenu">
        {this.state.modules.map((col, index) => (
           <li  key={index} className={this.props.disabled ? "disabled" : "enabled"}>
            <Link
              className={location.pathname === col.url ? "submit" : ''}
              id={col.nombre}
              to={col.url}
            >
              <span className={`icon dripicons-${col.icon}`} />
              <b>{col.nombre}</b>
            </Link>
          </li>
        ))}

      </ul>
    );
  }
}

MenuList.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  menu: state.menu.menu,
  modules: state.modulos.modulos
})

export default connect(mapStateToProps, { SetMenuManager, setModulos })(withRouter(MenuList));
